// extracted by mini-css-extract-plugin
export default {"content__wrap":"DetailLog_content__wrap__jibAb","content__wrap__log":"DetailLog_content__wrap__log__FEKTF"};